import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadFlssoListStatus: 'idle',
    loadFlssoListError: undefined as any,
    loadFlssoListLastArgs: undefined as any,
    loadFlssoStatus: 'idle',
    loadFlssoError: undefined as any,
    saveFlssoStatus: 'idle',
    saveFlssoError: undefined as any,
    deleteFlssoStatus: 'idle',
    deleteFlssoError: undefined as any,

    flssoList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadFlssoList = createAsyncThunk('flssoSlice/loadFlssoList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flssoSlice.loadFlssoListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/flsso/?action=eql&OBJ=${parentModel.OBJNR}&FLNO=${parentModel.FLSTMNR}&MIN_ATTRIB=0&MAX_ATTRIB=9999&MIN_DAT=MINDATE&MAX_DAT=MAXDATE`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadFlssoListStatus } = getState().flssoSlice
        return loadFlssoListStatus !== 'pending'
    }
})

export const loadFlsso = createAsyncThunk('flssoSlice/loadFlsso', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flsso/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadFlssoStatus } = getState().flssoSlice
        return loadFlssoStatus !== 'pending'
    }
})

export const saveFlsso = createAsyncThunk('flssoSlice/saveFlsso', async ({ flsso }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flsso?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flsso/${ flsso?.HDR_ID }/`,
            prepareData(flsso),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flsso/`,
            prepareData(flsso),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveFlssoStatus } = getState().flssoSlice
        return saveFlssoStatus !== 'pending'
    }
})

export const deleteFlsso = createAsyncThunk('flssoSlice/deleteFlsso', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flsso/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteFlssoStatus } = getState().flssoSlice
        return deleteFlssoStatus !== 'pending'
    }
})

const FlssoSlice = createSlice({
    name: 'flssoSlice',
    initialState,
    reducers: {
        resetloadFlssoListError: (state) => {
            state.loadFlssoListError = undefined
        },
        resetloadFlsso: (state) => {
            state.formItem = undefined
            state.loadFlssoError = undefined
        },
        resetloadFlssoError: (state) => {
            state.loadFlssoError = undefined
        },
        resetsaveFlsso: (state) => {
            state.formItem = undefined
            state.saveFlssoError = undefined
        },
        resetsaveFlssoError: (state) => {
            state.saveFlssoError = undefined
        },
        resetdeleteFlssoError: (state) => {
            state.deleteFlssoError = undefined
        },
        removeFromFlssoListById: (state, action) => {
            state.flssoList = state.flssoList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlssoListByIds: (state, action) => {
            state.flssoList = state.flssoList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flssoList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadFlssoListStatus = 'preloaded'
            state.loadFlssoListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flssoList = []
            state.loadFlssoListStatus = 'idle'
            state.loadFlssoListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadFlssoList.pending, (state) => {
            state.loadFlssoListStatus = 'pending'
            state.loadFlssoListError = undefined
        })
        builder.addCase(loadFlssoList.fulfilled, (state, action) => {
            state.loadFlssoListStatus = 'idle'

            if (!action.payload) { return }

            state.loadFlssoListLastArgs = action.payload.args

            {
                state.flssoList = action.payload.data

            }
        })
        builder.addCase(loadFlssoList.rejected, (state, action) => {
            state.loadFlssoListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadFlssoListError = action.error.message
            } else {
                state.loadFlssoListError = action.payload
            }
        })

        builder.addCase(loadFlsso.pending, (state) => {
            state.loadFlssoStatus = 'pending'
            state.loadFlssoError = undefined
        })
        builder.addCase(loadFlsso.fulfilled, (state, action) => {
            state.loadFlssoStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flssoList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flssoList.push(newItem) }
                else { state.flssoList[i] = { ...state.flssoList[i], ...newItem } }
            }
        })
        builder.addCase(loadFlsso.rejected, (state, action) => {
            state.loadFlssoStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadFlssoError = action.error.message
            } else {
                state.loadFlssoError = action.payload
            }
        })

        builder.addCase(saveFlsso.pending, (state) => {
            state.saveFlssoStatus = 'pending'
            state.saveFlssoError = undefined
        })
        builder.addCase(saveFlsso.fulfilled, (state, action) => {
            state.saveFlssoStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flssoList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flssoList.push(newItem) }
                else { state.flssoList[i] = { ...state.flssoList[i], ...newItem } }
            }
        })
        builder.addCase(saveFlsso.rejected, (state, action) => {
            state.saveFlssoStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveFlssoError = action.error.message
            } else {
                state.saveFlssoError = action.payload
            }
        })

        builder.addCase(deleteFlsso.pending, (state) => {
            state.deleteFlssoStatus = 'pending'
            state.deleteFlssoError = undefined
        })
        builder.addCase(deleteFlsso.fulfilled, (state, action) => {
            state.deleteFlssoStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.flssoList = state.flssoList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.flssoList = state.flssoList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteFlsso.rejected, (state, action) => {
            state.deleteFlssoStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteFlssoError = action.error.message
            } else {
                state.deleteFlssoError = action.payload
            }
        })

    }
})

export const {
    resetloadFlssoListError,
    resetloadFlsso,
    resetloadFlssoError,
    resetsaveFlsso,
    resetsaveFlssoError,
    resetdeleteFlssoError,
    removeFromFlssoListById,
    removeFromFlssoListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlssoSlice.actions
export default FlssoSlice.reducer
